import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown,
} from '../../common/form/FieldHelper';

class SaleTransactionDropdown extends Component {
  render() {
    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      preload = true,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
          dropdownType="sale_transaction"
          fields={['id', 'reference_id']}
          formId={form}
          name={name}
          onPostChange={onPostChange}
          preload={preload}
          searchFn={searchFn}
          textField="reference_id"
          type="sale_transaction"
          valueField="id"
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown,
    },
    dispatch,
  );
}

export default connect(
  null,
  mapDispatchToProps,
)(SaleTransactionDropdown);
